import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { Shadows } from '../../../../../play-core/styles/Shadows';
import { IconWrapper } from '../../IconWrapper/IconWrapper';
import { aspectRatioMap } from '../../Image/PlayImage';
import { gridChannelHeight, gridGap } from '../tv-guide-types';
export const Layout = styled.div.withConfig({
  displayName: "GridEntrystyles__Layout",
  componentId: "sc-1tx6aaq-0"
})(["display:flex;flex-direction:row;position:absolute;height:100%;overflow:hidden;background-color:", ";border-right:", "px solid ", ";cursor:pointer;&:hover{background-color:", ";z-index:", ";transition:all 0.2s ease-in-out;", ";}"], props => props.isActive ? Colors.GREY_454545 : Colors.GREY_222222, gridGap, Colors.GREY_1a1a1a, Colors.GREY_4a4a4a, props => props.isNow ? 50 : 85, Shadows.applyDouble(16));
export const Infos = styled.div.withConfig({
  displayName: "GridEntrystyles__Infos",
  componentId: "sc-1tx6aaq-1"
})(["padding:16px 8px 0 16px;display:flex;flex-direction:column;"]);
export const Time = styled.div.withConfig({
  displayName: "GridEntrystyles__Time",
  componentId: "sc-1tx6aaq-2"
})(["display:grid;grid-auto-flow:column;grid-gap:6px;grid-template-columns:auto 1fr;width:100%;color:", ";span{", ";white-space:nowrap;}"], Colors.GREY_969696, Fonts.regular(14));
export const InfoIcon = styled(IconWrapper).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "GridEntrystyles__InfoIcon",
  componentId: "sc-1tx6aaq-3"
})(["margin:-8px 4px;justify-content:flex-end;"]);
export const Title = styled.div.withConfig({
  displayName: "GridEntrystyles__Title",
  componentId: "sc-1tx6aaq-4"
})(["align-self:flex-start;", ";white-space:nowrap;line-height:34px;color:", ";"], Fonts.regular(18), Colors.GREY_d2d2d2);
export const SubTitle = styled.div.withConfig({
  displayName: "GridEntrystyles__SubTitle",
  componentId: "sc-1tx6aaq-5"
})(["", ";white-space:nowrap;color:", ";display:grid;grid-auto-flow:column;grid-gap:6px;align-items:center;align-self:flex-start;"], Fonts.light(16), Colors.GREY_969696);
export const NowMarker = styled.div.withConfig({
  displayName: "GridEntrystyles__NowMarker",
  componentId: "sc-1tx6aaq-6"
})(["height:2px;background-color:", ";position:absolute;bottom:0;left:0;"], Colors.RED_e71f2c);
export const tvGuideImageRatio = '3/2';
export const ImageContainer = styled.div.withConfig({
  displayName: "GridEntrystyles__ImageContainer",
  componentId: "sc-1tx6aaq-7"
})(["min-width:", "px;"], Math.round(gridChannelHeight * aspectRatioMap[tvGuideImageRatio]));